module.exports = __webpack_public_path__ + "media/src/website/images/locations/germering/profile-beeb73cd91f913a7934e1a4df7be64ad.jpg";